
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { GroupMasterForm } from "@univdiam/ui/customComponents/GroupMasterList/GroupMasterForm";
import axios from "axios";

const API_BASE_URL = import.meta.env.VITE_SERVER_URL;

interface GroupData {
  group_id: string;
  name: string;
  status: string;
}

export default function GroupMasterAdd() {
  const [groupData, setGroupData] = useState<GroupData[]>([]);
  const [subGroupData, setSubGroupData] = useState<GroupData[]>([]);
  const [subSubGroupData, setSubSubGroupData] = useState<GroupData[]>([]);
  const navigate = useNavigate();

  const handleAddGroupMaster = async (data: any) => {
    try {
      const response = await axios.post(`${API_BASE_URL}/api/group_masters/add`, data);
      if ([201, 200].includes(response.status)) {
        alert("Group Master created successfully!");
        navigate("/group_masters");
      }
    } catch (error) {
      console.error("Error creating group:", error);
      alert("Failed to create group.");
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [groupsRes, subGroupsRes, subSubGroupsRes] = await Promise.all([
          axios.get(`${API_BASE_URL}/api/groups`),
          axios.get(`${API_BASE_URL}/api/sub_groups`),
          axios.get(`${API_BASE_URL}/api/sub_sub_groups`)
        ]);

        setGroupData(groupsRes.data.data.map((g: any) => ({
          id: g.group_id,
          name: g.name,
          status: g.status === 1 ? "Enabled" : "Disabled"
        })));

        setSubGroupData(subGroupsRes.data.data.map((g: any) => ({
          id: g.sub_group_id,
          name: g.name,
          status: g.status === 1 ? "Enabled" : "Disabled"
        })));

        setSubSubGroupData(subSubGroupsRes.data.data.map((g: any) => ({
          id: g.sub_sub_group_id,
          name: g.name,
          status: g.status === 1 ? "Enabled" : "Disabled"
        })));
      } catch (err) {
        console.error("Failed to fetch data", err);
        navigate("/group_masters");
      }
    };

    fetchData();
  }, [navigate]);

  const handleGroupChange = async (groupId: string) => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/group_masters/sub_groups/${groupId}`);
      return response.data.data.map((item: any) => ({
        id: item.sub_group_id,
        name: item.name,
        status: item.status === 1 ? "Enabled" : "Disabled"
      }));
    } catch (error) {
      console.error("Failed to fetch sub groups:", error);
      return [];
    }
  };

  const handleSubGroupChange = async (subGroupId: string) => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/group_masters/sub_sub_groups/${subGroupId}`);
      return response.data.data.map((item: any) => ({
        id: item.sub_sub_group_id,
        name: item.name,
        status: item.status === 1 ? "Enabled" : "Disabled"
      }));
    } catch (error) {
      console.error("Failed to fetch sub sub groups:", error);
      return [];
    }
  };

  return (
    <div className="p-6 max-w-2xl mx-auto">
      <h1 className="text-2xl font-bold mb-6">Create New Group Master</h1>
      <GroupMasterForm 
        onSubmit={handleAddGroupMaster}
        groupValues={groupData}
        subGroupValues={subGroupData}
        subSubGroupValues={subSubGroupData}
        fetchSubGroups={handleGroupChange}
        fetchSubSubGroups={handleSubGroupChange}
      />
    </div>
  );
}